import { RefreshCw } from 'lucide-react'
import { useState } from 'react'

import { Button } from '../../components/ui'
import {
  activatePwaUpdate,
  dismissPwaUpdate,
  usePwaLifecycle,
} from '../../services/pwaLifecycle'

export function PwaStatus() {
  const lifecycle = usePwaLifecycle()
  const [updateError, setUpdateError] = useState(false)

  async function update(): Promise<void> {
    setUpdateError(false)
    try {
      await activatePwaUpdate()
    } catch {
      setUpdateError(true)
    }
  }

  if (lifecycle.updatePromptVisible) {
    return (
      <aside className="pwa-status" role="status" aria-live="polite">
        <RefreshCw size={19} aria-hidden="true" />
        <div><strong>Une nouvelle version de Caravan est disponible</strong><span>Choisissez quand l’activer.</span></div>
        <div className="pwa-status__actions">
          <Button variant="ghost" onClick={dismissPwaUpdate}>Plus tard</Button>
          <Button disabled={lifecycle.updating} onClick={() => void update()}>{lifecycle.updating ? 'Mise à jour…' : 'Mettre à jour'}</Button>
        </div>
        {updateError ? <p role="alert">Mise à jour impossible pour le moment. Réessayez après reconnexion.</p> : null}
      </aside>
    )
  }

  return null
}
